import axios from "axios";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const useAxios = () => {
  //   const navigate = useNavigate();
  const apiClient = axios.create({
    // baseURL: ROUTES.BASE_URL,
    baseURL: process.env.REACT_APP_BASE_URL,
    //   timeout: 5000,
  });
  const conUser = useSelector((state) => state?.conUser);

  useEffect(() => {
    apiClient.interceptors.request.use(
      async (config) => {
        if (conUser?.token)
          config.headers["Authorization"] = `Bearer ${conUser?.token}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    apiClient.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          console.log("Token expired or unauthorized");
          //   navigate("/login"); // Redirect to login
        }
        return Promise.reject(error);
      }
    );
    //   }, [navigate]);
    // eslint-disable-next-line
  }, [apiClient]);

  return apiClient;
};

export default useAxios;
